import React from 'react';
import { Link } from 'react-router-dom';
import { useAgreementGate } from './useAgreementGate';
import { agreementCopy } from './agreementCopy';

/** Profile page entry to the partner agreement: its status and a link to view, sign or renew it. */
const AgreementSummaryCard: React.FC = () => {
  const { esignEnabled, status, validUntil, renewBy } = useAgreementGate();

  const copy = esignEnabled ? agreementCopy(status, validUntil, renewBy) : null;
  if (!copy) {
    return null;
  }

  return (
    <div className="bg-black/[0.04] rounded-lg px-6 py-4 mt-6 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
      <div>
        <h3 className="text-stone-500 font-semibold text-xs uppercase mb-1">Partner Agreement</h3>
        <h4 className="text-sm font-medium text-slate-800">{copy.card}</h4>
      </div>
      <Link
        to="/agreement"
        className="shrink-0 text-center h-9 leading-9 rounded-lg px-4 text-sm font-semibold text-white bg-green-700"
      >
        {copy.action}
      </Link>
    </div>
  );
};

AgreementSummaryCard.displayName = 'AgreementSummaryCard';

export default AgreementSummaryCard;
